import React, { useReducer } from 'react';

/**
 * @type {React.Context<ReturnType<typeof useLoadingHandler>>}
 */
const LoadingContext = React.createContext();

const InitialState = {
  loadingMap: {},
  loading: false,
};

function isLoadingSomething(state = {}) {
  return Object.values(state).some((value) => value);
}

function handleSetLoading(prevState, key, isLoading) {
  const loadingMap = {
    ...prevState.loading,
    [key]: isLoading,
  };

  const next = {
    ...prevState,
    loadingMap,
    loading: isLoadingSomething(loadingMap),
  };

  return next;
}

function useLoadingHandler() {
  const [state, dispatch] = useReducer((prevState, action) => {
    switch (action.type) {
      case 'SET_LOADING':
        return handleSetLoading(prevState, action.key, action.isLoading);
      default:
        return prevState;
    }
  }, InitialState);

  const setLoading = (key = '', isLoading = false) => {
    if (!key) return;
    dispatch({ type: 'SET_LOADING', key, isLoading });
  };

  return {
    loading: state.loading,
    loadingMap: state.loadingMap,
    setLoading,
  };
}

export function LoadingProvider({ children }) {
  const loadingHandler = useLoadingHandler();
  return <LoadingContext.Provider value={loadingHandler}>{children}</LoadingContext.Provider>;
}

export function useLoading() {
  const context = React.useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
}
